import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import ShopperLogin from "../../../components/shopperLogin/ShopperLogin";
import ShopperLoginMobileConatiner from "../../../components/shopperLogin/ShopperLoginMobileConatiner";
import { useDispatch, useSelector } from "react-redux";
import { checkTheShopperRefIsCorrect, generateDynamicStyling, getStandaloneAffirmItem, getStorage, isEmpty } from "../../../../Utils/utils";
import Loading from "../../../components/loadingScreen/Loading";
import BottomFooter from "../../../components/checkoutFooter/BottomFooter";
import "./mobileLayout.css";
import "../styles.css";
import "../../../components/fontStyling.css";
import DeliveryAddress from "../../../components/address/deliveryAddress";
import AdditionalInformation from "../../../components/additionalInformation/AdditionalInformation";
import { PaymentSummaryMobileContainer } from "../../../components/paymentSummary/PaymentSummaryMobileContainer";
import PaymentSummary from "../../../components/paymentSummary/PaymentSummary";
import OrderSummaryMobileContainer from "../../../components/orderSummary/OrderSummaryMobileContainer";
import OrderSummary from "../../../components/orderSummary/OrderSummary";
import PaymentOptions from "../../../components/paymentOptions/PaymentOptions";
import LogoutMobile from "../../../components/logout/LogoutMobile";
import PaymentButton from "../../../components/paymentButton/PaymentButton";
import {
  getSavedIntsruments,
  selectSavedInstruments,
  selectSelectedIntrument,
  setSavedInstruments,
  updateSelectedInstruments,
} from "../../../../slices/SavedInstrumentSlice";
import {
  changeActivePaymentMethod,
  selectActivePaymentMethod,
} from "../../../../slices/PaymentButtonSlice";
import { changeUpiVpa } from "../../../../slices/UpiSlice";
import ErrorPage from "../../../components/errorPages/errorPage";
import {
  selectExpiryTimeStamp,
  selectIsAdditionalInfoPending,
  setIsSessionInvalid,
  updatePaymentMethodDictionary,
  updateShopperDetails,
  updateUniqueReference,
} from "../../../../slices/PaymentSessionDetailsSlice";
import {
  resetShopperInfo,
  selectGuestCheckout,
  selectIsGuestLoggedIn,
  selectShowLogin,
  selectMobileNumber,
} from "../../../../slices/ShopperInfoSlice";
import { selectUnauthorised, resetUnauthorised } from "../../../../slices/ApiErrorSlice";
import { Typography } from "antd";
import ExpiryTimer from "../../../resuableComponents/ExpiryTimer";
import { checkoutLoadedAnalytics } from "../../../../Utils/uiAnalytics";
import GuestLogoutMobile from "../../../components/logout/GuestLogoutMobile";
import TranslateText from "../../../resuableComponents/TranslateText";
import OnDemand from "../../../components/OnDemand/OnDemand";
import Offers from "../../../components/Offers/Offers";
import WalletPay from "../../../components/paymentOptions/WalletPay/WalletPay";

const MobileLayout = () => {
  const { t } = useTranslation()
  const sessionDetails = useSelector((state) => state.paymentSessionDetails.sessionDetails);
  const tokenType = useSelector(
    (state) => state.paymentSessionDetails.tokenType
  );
  const unauthorised = useSelector((state) => selectUnauthorised(state));
  const guestCheckout = useSelector((state) => selectGuestCheckout(state));
  const isLoggedIn = useSelector((state) => state.shopperInfo.isLoggedIn);
  const activePaymentMethod = useSelector((state) => selectActivePaymentMethod(state));
  const isSessionExpired = useSelector((state) => state.paymentSessionDetails.isSessionExpired);
  const callerType = useSelector((state) => state.paymentSessionDetails.callerType);
  const isSessionInvalid = useSelector((state) => state.paymentSessionDetails.isSessionInvalid);
  const technicalError = useSelector((state) => state.paymentSessionDetails.technicalError);
  const sessionErrorReasonCode = useSelector((state) => state.paymentSessionDetails.sessionErrorReasonCode);
  const addressCollapse = useSelector((state) => state.paymentSessionDetails.addressCollapse);
  const isAdditionalInfoPending = useSelector(selectIsAdditionalInfoPending);
  const showLogin = useSelector(selectShowLogin);
  const isShippingAddressDisplay = useSelector((state) => state.paymentSessionDetails.isShippingAddressDisplay);
  const { showEmailAddress, showFullName, showContactNumber } = useSelector((state) => state.additionalComponents);
  const [loading, setLoading] = useState(true);
  const savedInstruments = useSelector((state) => selectSavedInstruments(state));
  const [duration, setDuration] = useState(null);
  const expiryTimeStamp = useSelector((state) => selectExpiryTimeStamp(state));
  const isShowTimerExpiry = useSelector((state) => state.additionalComponents.isShowTimerExpiry);
  const showOrderItem = useSelector((state) => state.additionalComponents.showOrderItem);
  const isGuestLoggedIn = useSelector(selectIsGuestLoggedIn);
  const showTotalPaymentSummaryField = useSelector((state) => state.additionalComponents.showTotalPaymentSummaryField);
  const paymentMethodDictionary = useSelector((state) => state.paymentSessionDetails.paymentMethodDictionary);
  const paymentMethodDictionaryAll = useSelector((state) => state.paymentSessionDetails.paymentMethodDictionaryAll);
  const sessionDetailsLoaded = useSelector((state) => state.paymentSessionDetails.sessionDetailsLoaded);

  const dispatch = useDispatch();
  const onDemandLoaded = useSelector((state) => state.commonPersisted.onDemandLoaded);
  const searchParams = new URLSearchParams(document.location.search);
  const checkoutTokenParams = searchParams.get("token")
  const shopperRef = useSelector((state) => selectMobileNumber(state));
  const isGooglePayAvailable = paymentMethodDictionaryAll?.Wallet?.find(el => el.brand == "GooglePay")
  const isGooglePayAvailableRender = useSelector(state => state.gpayDetails.isGooglePayAvailable)
  const isApplePayAvailableRender = useSelector(state => state.gpayDetails.isApplePayAvailable)
  const isApplePayAvailable = paymentMethodDictionaryAll?.Wallet?.find(el => el.brand == "ApplePay")
  const isRevolutPayAvailable = paymentMethodDictionaryAll?.Wallet?.find(el => el.brand == "RevolutPay")
  const isAffirmAvailable = !!getStandaloneAffirmItem(paymentMethodDictionaryAll)

  const handleContinuePayment = () => {
    window.open(window.location.href, "_blank", "noopener,noreferrer");
  };

  const errorMessage = useSelector(
    (state) => state.paymentSessionDetails.errorMessage
  );

  useEffect(() => {
    if (expiryTimeStamp) {
      const newDate = new Date();
      const expTime = new Date(expiryTimeStamp);
      const timeDiff = expTime - newDate;
      const diffInSeconds = Math.floor(timeDiff / 1000);
      setDuration(diffInSeconds);
    }
  }, [expiryTimeStamp]);

  useEffect(() => {
    const searchParams = new URLSearchParams(document.location.search);
    const token = searchParams.get("token");
    if (
      token !== sessionDetails?.token ||
      !sessionDetailsLoaded ||
      !sessionDetails?.token ||
      !shopperRef ||
      !checkTheShopperRefIsCorrect(
        shopperRef,
        sessionDetails?.paymentDetails?.shopper?.uniqueReference
      )
    ) return;
    if (sessionDetails) {
      generateDynamicStyling(sessionDetails);
    }
    let checkoutToken = checkoutTokenParams || sessionDetails?.token
    if (isLoggedIn && !guestCheckout && checkoutToken && !isEmpty(sessionDetails)) {

      // let shopperRef = ""
      // if(getCookieValue('shopper_token'))
      // sessionDetails?.paymentDetails?.shopper?.uniqueReference || localStorage.getItem("shopperRef");
      dispatch(getSavedIntsruments({ checkoutToken: checkoutToken, shopperRef }));
    }

  }, [sessionDetails, isLoggedIn, shopperRef, sessionDetailsLoaded]);

  useEffect(() => {
    if (savedInstruments?.length >= 0) {
      dispatch(
        updatePaymentMethodDictionary({
          Recommended: savedInstruments,
        })
      );
    }
  }, [savedInstruments]);

  useEffect(() => {
    if (sessionDetails) {
      const delay = setTimeout(() => {
        setLoading(false);
      }, 500);

      return () => clearTimeout(delay);
    }
  }, [sessionDetails]);

  useEffect(() => {
    if (unauthorised) {
      dispatch(resetShopperInfo());
      dispatch(setSavedInstruments([]));
      dispatch(resetUnauthorised());
    }
  }, [unauthorised]);

  useEffect(() => {
    if (activePaymentMethod !== 'Card') {
      dispatch(updateSelectedInstruments(null));
    }
    dispatch(changeUpiVpa(null));
  }, [activePaymentMethod]);

  useEffect(() => {
    if (sessionDetails) {
      const isCheckoutDomain = window.location.hostname.includes(
        "checkout.boxpay.tech"
      );
      const isNewCheckoutDomain = window.location.hostname.includes(
        "checkout-v2.boxpay.tech"
      );
      const isPaymentLinkDomain =
        window.location.hostname.includes("pl.boxpay.tech");
      if (
        (callerType === "PAYMENT_LINK" &&
          (isCheckoutDomain || isNewCheckoutDomain)) ||
        (callerType === "CHECKOUT" && isPaymentLinkDomain)
      ) {
        dispatch(setIsSessionInvalid(true));
      }
    }
  }, [sessionDetails, callerType]);

  const handleTimerExpire = () => {
    dispatch(setIsSessionInvalid(true));
  };
  const latestSavedAddress = useSelector(
    (state) => state.paymentSessionDetails.latestSavedAddress
  );
  // const shopperRef = localStorage.getItem("shopperRef");
  useEffect(() => {
    if (shopperRef) {
      dispatch(updateUniqueReference(shopperRef));
    } else if (latestSavedAddress) {
      const selectedCardData = latestSavedAddress;
      const currentPhoneNumber = selectedCardData?.phoneNumber;
      const currentEmail = selectedCardData?.email;
      if (
        sessionDetails?.paymentDetails?.shopper?.phoneNumber !==
        currentPhoneNumber
      ) {
        dispatch(updateUniqueReference(currentPhoneNumber));
      }
      if (sessionDetails?.paymentDetails?.shopper?.email !== currentEmail) {
        dispatch(updateUniqueReference(currentEmail));
      }
      if (
        sessionDetails?.paymentDetails?.shopper?.phoneNumber ===
        currentPhoneNumber &&
        sessionDetails?.paymentDetails?.shopper?.email === currentEmail
      ) {
        dispatch(
          updateUniqueReference(
            sessionDetails?.paymentDetails?.shopper?.phoneNumber ||
            sessionDetails?.paymentDetails?.shopper?.uniqueReference
          )
        );
      }
      dispatch(updateShopperDetails({ selectedCardData }));
    }
  }, [sessionDetails, latestSavedAddress, shopperRef]);
  const selectedInstrument = useSelector((state) =>
    selectSelectedIntrument(state)
  );

  useEffect(() => {
    if (savedInstruments?.length > 0) {
      dispatch(changeActivePaymentMethod("Recommended"));
    }
  }, [savedInstruments]);

  return (
    <>
      {loading ? (
        <Loading
          text={t("TAKING_BACK_TO_CHECKOUT")}
          subText={t("NOTE_AVOID_BACK_BUTTON")}
        />
      ) : (
        <>
          {isSessionExpired ? (
            <ErrorPage
              imgUrl="/assets/errorImage/sessionExpired.svg"
              heading={
                callerType === "PAYMENT_LINK"
                  ? t("EXPIRED_PAYMENT_LINK")
                  : t("EXPIRED_SESSION")
              }
              subHeading={
                callerType === "PAYMENT_LINK"
                  ? t("EXPIRED_PAYMENT_LINK")
                  : t("GO_BACK_TRY_AGAIN")
              }
            />
          ) : isSessionInvalid ? (
            <ErrorPage
              imgUrl="/assets/errorImage/invalidSession.svg"
              heading={
                callerType === "PAYMENT_LINK"
                  ? t("INVALID_PAYMENT_LINK")
                  : t("INVALID_SESSION")
              }
              subHeading={
                callerType === "PAYMENT_LINK"
                  ? t("CHANGE_URL_CHECK_AGAIN")
                  : t("CONTACT_SUPPORT")
              }
            />
          ) : technicalError ? (
            <ErrorPage
              imgUrl="/assets/errorImage/technical.svg"
              heading={sessionErrorReasonCode === "BE_1607" ? (tokenType === "checkout-token" ? t("INVALID_CHECKOUT_TOKEN") : t("INVALID_PAYMENT_LINK")) : t("TECHNICAL_ERROR")}
              subHeading={sessionErrorReasonCode === "BE_1607" ? (tokenType === "checkout-token" ? t("CONTACT_MERCHANT") : t("CONTACT_PAYMENT_LINK_PROVIDER")) : <> <Typography>
                <TranslateText label={"TEMPORARY_ISSUE_MESSAGE"}>We ran into a temporary issue. Please</TranslateText>{" "}
                <span className="errorRetryLink" onClick={handleContinuePayment}>
                  <TranslateText label={"CLICK_HERE"}>click here</TranslateText>
                </span>{" "}
                <TranslateText label={"RELOAD_AND_CONTINUE_PAYMENT"}>to reload the page and continue your Payment.</TranslateText>
              </Typography></>}
              errorDetails={errorMessage}
              showContactSupport={true}
            />
          ) : showTotalPaymentSummaryField && !onDemandLoaded ? (
            <OnDemand isMobile={true} />
          ) : (
            <div className="domestic-m-layout-root dynamic-font-family">
              {
                (showEmailAddress || showFullName || showContactNumber || isShippingAddressDisplay || (isShowTimerExpiry && duration)) && (
                  <div
                    className="review-pay-container"
                    style={{ display: "flex", justifyContent: "space-between" }}
                  >
                    <Typography className="medium16Heading">
                      <TranslateText label={"REVIEW_AND_PAY"}>Review & Pay</TranslateText>
                    </Typography>
                    {isShowTimerExpiry && duration && (
                      <>
                        <Typography
                          className="regular16Heading"
                          style={{ color: "var(--Neutral-Grey-1000)" }}
                        >
                          <TranslateText label={"WITHIN"}>within</TranslateText>
                          <span
                            className="regular16Heading"
                            style={{
                              color: "var(--Red-900)",
                              fontWeight: 600,
                              paddingLeft: '0.5rem'
                            }}
                          >
                            <ExpiryTimer
                              duration={duration}
                              callback={handleTimerExpire}
                            />
                          </span>
                        </Typography>
                      </>
                    )}
                  </div>
                )
              }

              {showOrderItem &&
                (sessionDetails?.paymentDetails?.order?.items?.length ||
                  sessionDetails?.paymentDetails?.product ||
                  sessionDetails?.description ||
                  sessionDetails?.paymentDetails?.context?.orderId ||
                  sessionDetails?.paymentDetails?.subscriptionDetails) && (
                  <OrderSummaryMobileContainer children={<OrderSummary />} />
                )}
              <PaymentSummaryMobileContainer children={<PaymentSummary />} />
              {sessionDetails?.anyOfferAvailable && <Offers />}
              {!showLogin ? (
                <>
                  <DeliveryAddress />
                  <AdditionalInformation />
                </>
              ) : (
                <ShopperLoginMobileConatiner children={<ShopperLogin />} />
              )}

              {!showLogin &&
                addressCollapse &&
                !isAdditionalInfoPending && (
                  <>
                    {/* Mirror hasExpressWalletAvailable in PaymentOptionsContainer: a GooglePay/ApplePay
                        item without additionalData renders no button, so it must not open the strip. */}
                    {((!isEmpty(isGooglePayAvailable?.additionalData) && isGooglePayAvailableRender) || (!isEmpty(isApplePayAvailable?.additionalData) && isApplePayAvailableRender) || isRevolutPayAvailable || isAffirmAvailable) &&
                      <div className="additional-payment-method-container" style={{ minHeight: "67px" }}>
                        <div style={{ minHeight: "47px", width: "100%" }}>
                          <WalletPay />
                        </div>
                        <div className="pay-with-text-container">
                          <hr className="pay-with-line"></hr>
                          <p className="pay-with-text" >  or pay with </p>
                          <hr className="pay-with-line"></hr>
                        </div>
                      </div>}
                    <PaymentOptions />
                    <PaymentButton />
                  </>
                )}
              {isLoggedIn && <LogoutMobile />}
              {isGuestLoggedIn && <GuestLogoutMobile />}
              <BottomFooter />
            </div>
          )}
        </>
      )}
    </>
  );
};

export default MobileLayout;
